import { takeEvery, call, put } from "redux-saga/effects";
import { buildGETUrl } from "../../utilities/buildGETUrl";
import {
  ADD_VIDEOS_TO_LISTS,
  loading,
  loadVideolist,
  loadVideolists,
} from "../../store/ContentVideolists/actions";
import { showAlertError, showAlertSuccess } from "../../store/Alert/actions";
import axios from "axios";

export default function* () {
  yield takeEvery(ADD_VIDEOS_TO_LISTS, worker);
}

function* worker({ payload }) {
  yield put(loading(true));
  try {
    const added = yield call(fetchAdd, payload);
    if (added.error) {
      yield put(
        showAlertError({
          errors: [`Ошибка сервера при ${ADD_VIDEOS_TO_LISTS}.`, added],
          text: "Видео не были добавлены. Попробуйте повторить.",
        }),
      );
    } else {
      yield put(
        showAlertSuccess({
          text: "Список успешно изменен.",
        }),
      );

      yield put(loadVideolists({ added: payload.videolist_ids }));
      yield put(loadVideolist(payload.videolist_ids[0]));
    }
  } catch (e) {
    yield put(
      showAlertError({
        errors: [`Ошибка сети при ${ADD_VIDEOS_TO_LISTS}.`, e],
        text: "Видео не были добавлены. Попробуйте повторить.",
      }),
    );
  } finally {
    // yield put(loading(false));
  }
}

function fetchAdd(addData) {
  let formData = new FormData();
  addData.tracks_ids.forEach((id) => {
    formData.append("tracks_ids[]", id);
  });

  const playlists_ids = addData.videolist_ids
    .map((el) => `videolist_ids[]=${el}`)
    .join("&");

  return axios({
    url: `/videolist/tracks/insert?${playlists_ids}`,
    method: "POST",
    data: formData,
  }).then((response) => response.data);
}
